var $4070a73c768a21e0$exports = {};
function $4070a73c768a21e0$var$addClassOnScroll(sectionClass, className) {
    const sections = document.getElementsByClassName(sectionClass);
    function checkSectionPosition() {
        Array.from(sections).forEach(function(section) {
            const sectionTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;
            const windowHeight = window.innerHeight;
            const scrollPosition = window.pageYOffset + windowHeight / 2;
            const video = section.querySelector('video');
            if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
                section.classList.add(className);
                setTimeout(function() {
                    video.play();
                }, 5000);
            }
        });
    }
    window.addEventListener('load', function() {
        checkSectionPosition();
        window.addEventListener('scroll', function() {
            checkSectionPosition();
        });
    });
}
$4070a73c768a21e0$var$addClassOnScroll('s-grid-images', 's-grid-images--animate');


//# sourceMappingURL=ecommerce-agency.decee858.js.map
